<template>
  <div class="login">
    <form @submit="onSubmit" v-if="!resetPasswordSuccess">
      <img src="../assets/images/powerslide-blue.svg" tabindex="-1" alt="Powerslide Logo" v-on:click="home" />

      <div class="message" v-bind:class="{error: validation.hasError('email')}">{{ validation.firstError('email') }}</div>
      <input type="text" v-bind:class="{errorInput: validation.hasError('email')}" v-model="email" placeholder="Email" tabindex="1" />

      <div class="message" v-bind:class="{error: validation.hasError('password')}" v-if="!forgotPassword">{{ validation.firstError('password') }}</div>
      <input type="password" v-bind:class="{errorInput: validation.hasError('password')}" v-model="password" v-if="!forgotPassword" placeholder="Password" tabindex="2" />

      <input type="submit" class="button" v-if="!forgotPassword" tabindex="3" text="Login" />

      <div class="button" v-on:click="resetPassword" v-if="forgotPassword">
        Reset My Password
      </div>

      <div class="error-response" v-if="loginError">
        Error: {{errorMessage}}
      </div>

      <div class="forgot-password-link" v-on:click="toggleForgotPassword">
        <div v-if="!forgotPassword">
          I forgot my password
        </div>

        <div v-if="forgotPassword">
          I remember my password
        </div>
      </div>

      <!-- <div class="create-account-link" v-on:click="createAccount">
        Don't have an account? Create one here
      </div> -->
    </form>

    <div v-if="resetPasswordSuccess">
      <img src="../assets/images/powerslide-blue.svg" v-on:click="home" alt="Powerslide Logo" />

      <h3>Success!</h3>
      If an account exists with this email address, you will receive an email containing a reset password link.

      <div class="login-link" v-on:click="goBack">
        Return to login
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Helpers from '../mixins/helpers.js'
import SimpleVueValidation from 'simple-vue-validator'
import '../styles/base.css'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      errorMessage: '',
      forgotPassword: false,
      loginError: false,
      password: '',
      resetPasswordSuccess: false
    }
  },

  mounted () {
    if (JSON.parse(localStorage.getItem('user'))) {
      if (this.isFireTV(PS.platform)) {
        this.$router.push('/setup')
      } else {
        this.$router.push('/dashboard')
      }
    }
  },

  methods: {
    createAccount () {
      this.$router.push('/create-account')
    },

    goBack () {
      this.errorMessage = ''
      this.forgotPassword = false
      this.resetPasswordSuccess = false
    },

    home: function () {
      this.$router.push('/')
    },

    login () {
      let data = {
        email: this.email,
        password: this.password
      }

      this.axios.post('/api/login', data).then((response) => {
        if (this.isFireTV(PS.platform)) {
          this.$gtag.event('device-login', { method: 'Google' })
          this.$router.push('/setup')
        } else {
          this.$gtag.event('dashboard-login', { method: 'Google' })
          this.$router.push('/dashboard')
        }
      }).catch((error) => {
        if (error.response.status === 400) {
          this.loginError = true
          this.errorMessage = error.response.data[2].message
        }
      })
    },

    resetPassword () {
      this.$validate('email')
        .then((success) => {
          if (success) {
            let data = {
              email: this.email
            }

            axios.post('/api/reset-password', data).then((response) => {
              this.resetPasswordSuccess = true
            }).catch(() => {
              this.loginError = true
              this.errorMessage = 'Password reset failed'
            })
          }
        })
    },

    onSubmit: function (e) {
      e.preventDefault()
      this.$validate()
        .then((success) => {
          if (success) {
            this.login()
          }
        })
    },

    toggleForgotPassword () {
      this.forgotPassword = !this.forgotPassword
      this.loginError = false
      this.errorMessage = ''
    }
  },

  mixins: [Helpers],

  validators: {
    email: function (value) {
      return Validator.value(value).required().email()
    },
    password: function (value) {
      return Validator.value(value).required().minLength(6)
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 400px;
  }

  .create-account-link {
    cursor: pointer;
    padding: 1em 2em 1em 2em;
    text-align: center;
  }

  .create-account-link:hover {
    color: var(--primary);
  }

  .error-response {
    color: var(--error);
    margin-top: 1em;
    text-align: center;
  }

  .forgot-password-link {
    cursor: pointer;
    margin-top: 1em;
    padding: 1em 2em;
    text-align: center;
  }

  .forgot-password-link:hover {
    color: var(--secondary-dark);
  }

  .form-group {
    text-align: left;
  }

  h3 {
    margin: 0 0 .5em 0
  }

  img {
    cursor: pointer;
    height: 100px;
  }

  .login {
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
  }

  .login-link {
    color: var(--primary);
    cursor: pointer;
    padding: .5em;
  }

  .login-link:hover {
    color: blue;
  }

  .logo {
    margin: 0 auto;
    text-align: center;
  }

  input {
    border: 1px solid var(--border-grey);
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: .5em;
    padding: 1em;
    width: 400px;
  }

  input:focus {
    outline: 5px solid var(--focus);
  }

  .message {
    height: 22px;
    margin-bottom: .5em;
    text-align: left;
  }

  .reset-success-container {
    background: white;
    border: 1px solid var(--border-grey);
    border-radius: 6px;
    margin: 0 auto;
    padding: 1.5em;
    position: relative;
    text-align: center;
    width: 400px;
  }

  @media only screen and (max-width: 420px) {
    .button {
      width: 300px;
    }

    .login-container {
      width: 300px;
    }

    img {
      width: 300px;
    }

    input[type=text], input[type=phone], input[type=email], input[type=password], textarea {
      width: 300px;
    }

    .logo {
      margin: 4em auto 0em;
    }
  }
</style>
